<lh-storage-location-item
  [storageLocation]="shop"
  [locationType]="locationType"
  [title]="title"
  [averageRating]="averageRating"
  [showAverageRating]="showAverageRating"
  [numberOfReviews]="numberOfReviews"
  [showNumberOfReviews]="showNumberOfReviews"
  [isRecommended]="isRecommended"
  [isOpen]="isOpen"
  [openingHours]="openingHours | timeInterval: true | async"
  [nextOpenDay]="nextOpenDay"
  [isFullyBooked]="isFullyBooked"
  [locationInfo]="locationInfo"
  [isMultiDayStorageAllowed]="isMultiDayStorageAllowed"
  [secondaryActionsMenuTitle]="'MANAGE'"
  [footnotePart1Html]="userCheckinRateHtml"
  [footnotePart2Html]="numberOfWalkinBookingsHtml"
  [footnoteTooltipHeaderHtml]="statsTooltipHeaderHtml"
  [footnoteTooltipBodyHtml]="statsTooltipBodyHtml"
  [actions]="actions"
  [badges]="badges"
  [compactMode]="true"
  [size]="'large'"
  *ngIf="isInitialized"
></lh-storage-location-item>
